import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
    setAddonProducts(state, payload) {
        state.addonProducts = payload;
    },
    setCategories(state, payload){
    state.categories = payload;
    },
    setSelectedSort(state,payload){
    state.selectedSort = payload;
    },
    setSelectedSortMobile(state,payload){
    state.selectedSortMobile = payload;
    },
    setRangePrice(state,payload){
    Vue.set(state, 'rangePrice', payload);
    },
    setRangePriceMobile(state,payload){
    Vue.set(state, 'rangePriceMobile', payload);
    },
    setAllSelectedCategory(state,payload){
    state.selectedCategory = payload;
    },
    setAllSelectedCategoryMobile(state,payload){
    state.selectedCategoryMobile = payload;
    },
    setSelectedCategoryMobile(state,payload){
    let currentIndex = state.selectedCategoryMobile.findIndex(x => x == payload);
    let allIndex = state.selectedCategoryMobile.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex)
        return
    if(currentIndex > -1){
        state.selectedCategoryMobile.splice(currentIndex, 1);
        if(state.selectedCategoryMobile.length == 0){
        state.selectedCategoryMobile = ["View All"];
        }
    }
    else{
        if(payload == "View All"){
        state.selectedCategoryMobile = ["View All"];
        }
        else{
        state.selectedCategoryMobile.push(payload);
        if(allIndex > -1){
            state.selectedCategoryMobile.splice(allIndex, 1);
        }
        }
    }
    },
};

export default mutations;
